import { getInitBind } from './bind';
import { getInitState } from './state';
import { getConfigure } from './configure';
export var init = function (opts) {
    getConfigure(opts);
    return {
        initState: getInitState(opts),
        initBind: getInitBind(opts),
    };
};
//# sourceMappingURL=init.js.map